var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[_c('Lotti'),_c('div',{staticClass:"my-8"}),_c('Torbe')],1)}
var staticRenderFns = []

export { render, staticRenderFns }